import React from 'react';
import { connectHits } from 'react-instantsearch-dom';
import styled from 'styled-components';
import CustomHit from './CustomHit';

const Wrapper = styled.div`
  max-width: 1920px;
  display: grid;
  grid-gap: 15px;
  grid-template-columns: 1fr 1fr 1fr 1fr;

  @media (max-width: 1300px) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media (max-width: 992px) {
    grid-template-columns: 1fr 1fr;
  }

  .image-container {
    padding-top: 30px;
  }
`;

const Hits = ({ hits, setShowSearch, searchParams }) => (
  <Wrapper>
    {hits.map(hit => (
      <div key={hit.objectID}>
        <CustomHit hit={hit} />
      </div>
    ))}
    {hits.length == 0 && (
      <div>
        <div className="d-block text-center">
          No results for this combination. Try a different filter.
        </div>
      </div>
    )}
  </Wrapper>
);

const CustomHits = connectHits(Hits);

export default CustomHits;
